import { SUBSCRIPTIONS } from '@/clients'
import { laravelErrorHandler } from '@/helpers'

const fetchCouponInfo = async couponStr => {
  const route = `coupon`
  try {
    const {
      data: { data },
    } = await SUBSCRIPTIONS.get(route, { params: { code: couponStr } })
    return data
  } catch (error) {
    throw laravelErrorHandler(error)
  }
}

export { fetchCouponInfo }
